import React from "react";
import T from "prop-types";
import { useTranslate } from "react-admin";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

export const SelectAllCheckbox = ({ selectedCount, totalCount, onToggle, style }) => {
	const translate = useTranslate();
	const allSelected = totalCount > 0 && selectedCount === totalCount;
	const someSelected = selectedCount > 0 && selectedCount < totalCount;

	return (
		<FormControlLabel
			control={
				<Checkbox
					checked={allSelected}
					indeterminate={someSelected}
					onChange={() => onToggle(!allSelected)}
				/>
			}
			label={translate("osfc.buttons.select_all")}
			style={style}
		/>
	);
};

SelectAllCheckbox.propTypes = {
	selectedCount: T.number.isRequired,
	totalCount: T.number.isRequired,
	onToggle: T.func.isRequired,
	style: T.object,
};
